import { gql } from "@/generated"

export const getOrganizationQuery = gql(`
  query Organization($memberInviteToken: String){
    organization(memberInviteToken: $memberInviteToken){
      id
      name
    }
  }
`)

export const createOrgAdminUserMutation = gql(`
  mutation CreateOrgAdminUser($input: CreateOrgAdminUserInput!){
    createOrgAdminUser(input: $input) {
      user {
        id
      }
      errors {
        path
        fullMessages
      }
    }
  }
`)
